
"use strict";

// =====================================================
// DECRETO - BONIFICACIÓN DECRETO
//
// Archivo:
// src/fronend/Ingresos/decreto/decreto.js
// =====================================================

// =====================================================
// COLUMNAS
// =====================================================
//
// 1.  #
// 2.  ID Ingreso
// 3.  Fecha ingreso
// 4.  Empleado
// 5.  DPI
// 6.  Puesto
// 7.  Dirección
// 8.  Salario base
// 9.  Días laborales
// 10. Horas establecidas
// 11. Horas extras
// 12. Pago ordinario
// 13. Pago hora extra
// 14. Total horas extras
// 15. Horas dobles
// 16. Pago hora doble
// 17. Total horas dobles
// 18. Total extras y dobles
// 19. Bonificación decreto
// 20. Pago total por bonificación
// 21. Estado
// 22. Acciones
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosDecreto = [];

let moduloInicializado = false;


// =====================================================
// VALOR FIJO BONIFICACIÓN DECRETO
// =====================================================

const VALOR_BONIFICACION_DECRETO = 250;


// =====================================================
// INICIALIZAR MÓDULO
// =====================================================

function inicializarDecreto() {

    if (moduloInicializado) {

        return;

    }

    moduloInicializado = true;

    cargarTablaDecreto();

}


// =====================================================
// CARGAR TABLA DECRETO
// =====================================================

async function cargarTablaDecreto() {

    try {

        const tbody =
            document.getElementById(
                "tbodyDecreto"
            );


        if (!tbody) {

            console.error(
                "No se encontró el elemento #tbodyDecreto"
            );

            return;

        }


        // =================================================
        // MENSAJE DE CARGA
        // =================================================

        tbody.innerHTML = `

            <tr>

                <td
                    colspan="22"
                    class="text-center py-4">

                    <div
                        class="spinner-border spinner-border-sm text-success me-2"
                        role="status">

                        <span class="visually-hidden">
                            Cargando...
                        </span>

                    </div>

                    Cargando información...

                </td>

            </tr>

        `;


        // =================================================
        // CONSULTAR SERVIDOR
        // =================================================

        const respuesta =
            await fetch(
                "/decreto/listar",
                {
                    method: "GET",

                    headers: {
                        "Accept": "application/json"
                    }
                }
            );


        // =================================================
        // VALIDAR RESPUESTA HTTP
        // =================================================

        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // CONVERTIR JSON
        // =================================================

        const resultado =
            await respuesta.json();


        // =================================================
        // VALIDAR RESULTADO
        // =================================================

        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No fue posible cargar la información."
            );

        }


        // =================================================
        // GUARDAR REGISTROS
        // =================================================

        registrosDecreto =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        // =================================================
        // MOSTRAR TABLA
        // =================================================

        renderizarTablaDecreto();

    }
    catch (error) {

        console.error(
            "Error al cargar bonificación de decreto:",
            error
        );


        const tbody =
            document.getElementById(
                "tbodyDecreto"
            );


        if (tbody) {

            tbody.innerHTML = `

                <tr>

                    <td
                        colspan="22"
                        class="text-center text-danger py-4">

                        <i
                            class="bi bi-exclamation-triangle-fill me-2">
                        </i>

                        Error al cargar la información:

                        ${escapeHtmlDecreto(
                            error.message
                        )}

                    </td>

                </tr>

            `;

        }

    }

}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarTablaDecreto() {

    const tbody =
        document.getElementById(
            "tbodyDecreto"
        );


    if (!tbody) {

        console.error(
            "No se encontró #tbodyDecreto"
        );

        return;

    }


    // =================================================
    // SIN REGISTROS
    // =================================================

    if (
        !Array.isArray(
            registrosDecreto
        ) ||
        registrosDecreto.length === 0
    ) {

        tbody.innerHTML = `

            <tr>

                <td
                    colspan="22"
                    class="text-center text-muted py-4">

                    <i
                        class="bi bi-inbox fs-4 d-block mb-2">
                    </i>

                    No hay registros de
                    bonificación de decreto.

                </td>

            </tr>

        `;


        actualizarResumenDecreto();

        return;

    }


    // =================================================
    // GENERAR FILAS
    // =================================================

    tbody.innerHTML =
        registrosDecreto
            .map(
                (registro, indice) => {

                    return `

                        <tr>

                            <!-- 1. # -->

                            <td
                                class="text-center fw-bold">

                                ${indice + 1}

                            </td>


                            <!-- 2. ID INGRESO -->

                            <td
                                class="text-center">

                                ${escapeHtmlDecreto(
                                    registro.IDINGRESONO
                                )}

                            </td>


                            <!-- 3. FECHA INGRESO -->

                            <td
                                class="text-center">

                                ${formatearFechaDecreto(
                                    registro.FECHAINGRESO
                                )}

                            </td>


                            <!-- 4. EMPLEADO -->

                            <td
                                class="fw-semibold">

                                ${escapeHtmlDecreto(
                                    registro.NOMBREEMPLEADO
                                )}

                            </td>


                            <!-- 5. DPI -->

                            <td
                                class="text-center">

                                ${escapeHtmlDecreto(
                                    registro.DPI
                                )}

                            </td>


                            <!-- 6. PUESTO -->

                            <td>

                                ${escapeHtmlDecreto(
                                    registro.NOMBREPUESTO
                                )}

                            </td>


                            <!-- 7. DIRECCIÓN -->

                            <td>

                                ${escapeHtmlDecreto(
                                    registro.DIRECCION
                                )}

                            </td>


                            <!-- 8. SALARIO BASE -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.SALARIOBASE
                                )}

                            </td>


                            <!-- 9. DÍAS LABORALES -->

                            <td
                                class="text-center">

                                ${formatearNumeroDecreto(
                                    registro.CANTIDADLABORALES
                                )}

                            </td>


                            <!-- 10. HORAS ESTABLECIDAS -->

                            <td
                                class="text-center">

                                ${formatearNumeroDecreto(
                                    registro.HORASESTABLECIDAS
                                )}

                            </td>


                            <!-- 11. HORAS EXTRAS -->

                            <td
                                class="text-center">

                                ${formatearNumeroDecreto(
                                    registro.HORASEXTRAS
                                )}

                            </td>


                            <!-- 12. PAGO ORDINARIO -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.PAGOORDINARIAHREXTRA
                                )}

                            </td>


                            <!-- 13. PAGO HORA EXTRA -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.PAGOEXTRA
                                )}

                            </td>


                            <!-- 14. TOTAL HORAS EXTRAS -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.TOTALEXTRAPAGADO
                                )}

                            </td>


                            <!-- 15. HORAS DOBLES -->

                            <td
                                class="text-center">

                                ${formatearNumeroDecreto(
                                    registro.HRSDOBLES
                                )}

                            </td>


                            <!-- 16. PAGO HORA DOBLE -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.PAGOHRSDOBLE
                                )}

                            </td>


                            <!-- 17. TOTAL HORAS DOBLES -->

                            <td
                                class="text-end">

                                ${formatearMonedaDecreto(
                                    registro.TOTALHRSDOBLES
                                )}

                            </td>


                            <!-- 18. TOTAL EXTRAS Y DOBLES -->

                            <td
                                class="text-end fw-bold">

                                ${formatearMonedaDecreto(
                                    registro.TOTALEXTRASYDOBLES
                                )}

                            </td>


                            <!-- 19. BONIFICACIÓN DECRETO -->

                            <td
                                class="text-end fw-bold text-success">

                                Q ${formatearMonedaDecreto(
                                    obtenerBonificacionDecreto(
                                        registro
                                    )
                                )}

                            </td>


                            <!-- 20. PAGO TOTAL POR BONIFICACIÓN -->

                            <td
                                class="text-end fw-bold text-primary">

                                Q ${formatearMonedaDecreto(
                                    registro.PAGOTOTALPORBONIFICACION
                                )}

                            </td>


                            <!-- 21. ESTADO -->

                            <td
                                class="text-center">

                                ${generarEstadoDecreto(
                                    registro.ESTADO
                                )}

                            </td>


                            <!-- 22. ACCIONES -->

                            <td
                                class="text-center">

                                <button
                                    type="button"
                                    class="btn btn-success btn-sm"
                                    title="Pago de bonificación"
                                    onclick="pagarBonificacionDecreto(${registro.IDINGRESONO})">

                                    <i
                                        class="bi bi-cash-coin me-1">
                                    </i>

                                    Pagar

                                </button>

                            </td>

                        </tr>

                    `;

                }
            )
            .join("");


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    actualizarResumenDecreto();

}


// =====================================================
// OBTENER BONIFICACIÓN DECRETO
// =====================================================

function obtenerBonificacionDecreto(
    registro
) {

    const valorSQL =
        convertirNumeroDecreto(
            registro.BONIFICACIONDECRETO
        );


    if (valorSQL > 0) {

        return valorSQL;

    }


    return VALOR_BONIFICACION_DECRETO;

}


// =====================================================
// CALCULAR PAGO TOTAL BONIFICACIÓN - MODAL
// =====================================================
//
// OPERACIÓN:
//
// BONIFICACIÓN
// +
// TOTAL HORAS EXTRAS
// +
// TOTAL HORAS DOBLES
//
// =====================================================

function calcularPagoTotalBonificacionModal(
    registro
) {

    const bonificacion =
        obtenerBonificacionDecreto(
            registro
        );


    const totalHorasExtras =
        convertirNumeroDecreto(
            registro.TOTALEXTRAPAGADO
        );


    const totalHorasDobles =
        convertirNumeroDecreto(
            registro.TOTALHRSDOBLES
        );


    const pagoTotal =
        bonificacion +
        totalHorasExtras +
        totalHorasDobles;


    return pagoTotal;

}


// =====================================================
// GUARDAR BONIFICACIÓN DECRETO
// =====================================================
//
// Ejecuta:
//
// POST /decreto/guardar
//
// Envía:
//
// IDINGRESONO
// BONIFICACIONDECRETO
// PAGOTOTALPORBONIFICACION
// ESTADO
//
// =====================================================

async function guardarBonificacionDecreto() {

    try {

        // =================================================
        // BOTÓN
        // =================================================

        const boton =
            document.getElementById(
                "btnGuardarBonificacion"
            );


        if (!boton) {

            throw new Error(
                "No se encontró el botón #btnGuardarBonificacion."
            );

        }


        // =================================================
        // OBTENER ID
        // =================================================

        const idIngreso =
            Number(
                boton.dataset.idIngreso
            );


        if (
            !Number.isInteger(idIngreso) ||
            idIngreso <= 0
        ) {

            throw new Error(
                "No se encontró un IDINGRESONO válido."
            );

        }


        // =================================================
        // BUSCAR REGISTRO
        // =================================================

        const registro =
            registrosDecreto.find(
                item =>
                    Number(
                        item.IDINGRESONO
                    ) === idIngreso
            );


        if (!registro) {

            throw new Error(
                "No se encontró el registro seleccionado."
            );

        }


        // =================================================
        // OBTENER BONIFICACIÓN DEL MODAL
        // =================================================

        const elementoBonificacion =
            document.getElementById(
                "bonificacionDecreto"
            );


        let bonificacion;


        if (elementoBonificacion) {

            bonificacion =
                convertirNumeroDecreto(
                    elementoBonificacion.value
                );

        }
        else {

            bonificacion =
                obtenerBonificacionDecreto(
                    registro
                );

        }


        // =================================================
        // OBTENER PAGO TOTAL DEL MODAL
        // =================================================

        const elementoPagoTotal =
            document.getElementById(
                "pagoTotalPorBonificacion"
            );


        let pagoTotal;


        if (elementoPagoTotal) {

            pagoTotal =
                convertirNumeroDecreto(
                    elementoPagoTotal.value
                );

        }
        else {

            pagoTotal =
                calcularPagoTotalBonificacionModal(
                    registro
                );

        }


        // =================================================
        // ESTADO
        // =================================================

        const elementoEstado =
            document.getElementById(
                "estadoBonificacion"
            );


        const estado =
            elementoEstado &&
            elementoEstado.value
                ? String(
                    elementoEstado.value
                ).trim().toUpperCase()
                : "A";


        // =================================================
        // VALIDAR BONIFICACIÓN
        // =================================================

        if (
            !Number.isFinite(
                bonificacion
            ) ||
            bonificacion < 0
        ) {

            throw new Error(
                "La bonificación de decreto no es válida."
            );

        }


        // =================================================
        // VALIDAR PAGO TOTAL
        // =================================================

        if (
            !Number.isFinite(
                pagoTotal
            ) ||
            pagoTotal < 0
        ) {

            throw new Error(
                "El pago total por bonificación no es válido."
            );

        }


        // =================================================
        // DESHABILITAR BOTÓN
        // =================================================

        const textoOriginal =
            boton.innerHTML;


        boton.disabled = true;


        boton.innerHTML = `

            <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true">
            </span>

            Guardando...

        `;


        // =================================================
        // DATOS
        // =================================================

        const datos = {

            IDINGRESONO:
                idIngreso,

            BONIFICACIONDECRETO:
                Number(
                    bonificacion.toFixed(2)
                ),

            PAGOTOTALPORBONIFICACION:
                Number(
                    pagoTotal.toFixed(2)
                ),

            ESTADO:
                estado

        };


        console.log(
            "Datos enviados a /decreto/guardar:",
            datos
        );


        // =================================================
        // ENVIAR AL SERVIDOR
        // =================================================

        const respuesta =
            await fetch(
                "/decreto/guardar",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        // =================================================
        // LEER RESPUESTA
        // =================================================

        const textoRespuesta =
            await respuesta.text();


        let resultado;


        try {

            resultado =
                JSON.parse(
                    textoRespuesta
                );

        }
        catch (error) {

            console.error(
                "Respuesta no válida del servidor:",
                textoRespuesta
            );

            throw new Error(
                "El servidor no devolvió una respuesta JSON válida."
            );

        }


        // =================================================
        // VALIDAR HTTP
        // =================================================

        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                `Error HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // VALIDAR RESULTADO
        // =================================================

        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No fue posible guardar la bonificación."
            );

        }


        // =================================================
        // ACTUALIZAR REGISTRO LOCAL
        // =================================================

        registro.BONIFICACIONDECRETO =
            bonificacion;


        registro.PAGOTOTALPORBONIFICACION =
            pagoTotal;


        registro.ESTADO =
            estado;


        // =================================================
        // CERRAR MODAL
        // =================================================

        const elementoModal =
            document.getElementById(
                "modalBonificacion"
            );


        if (elementoModal) {

            if (
                typeof bootstrap !==
                "undefined"
            ) {

                const modal =
                    bootstrap.Modal.getOrCreateInstance(
                        elementoModal
                    );

                modal.hide();

            }

        }


        // =================================================
        // ACTUALIZAR TABLA
        // =================================================

        renderizarTablaDecreto();


        // =================================================
        // MENSAJE
        // =================================================

        alert(
            resultado.mensaje ||
            "Bonificación de decreto guardada correctamente."
        );


    }
    catch (error) {

        console.error(
            "Error al guardar bonificación de decreto:",
            error
        );


        alert(
            error.message ||
            "No fue posible guardar la bonificación."
        );

    }
    finally {

        // =================================================
        // RESTAURAR BOTÓN
        // =================================================

        const boton =
            document.getElementById(
                "btnGuardarBonificacion"
            );


        if (boton) {

            boton.disabled = false;

            boton.innerHTML = `

                <i
                    class="bi bi-save me-1">
                </i>

                Guardar

            `;

        }

    }

}


// =====================================================
// RESUMEN
// =====================================================

function actualizarResumenDecreto() {

    const totalRegistros =
        registrosDecreto.length;


    // =================================================
    // TOTAL EMPLEADOS
    // =================================================

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            totalRegistros;

    }


    // =================================================
    // TOTAL SALARIOS
    // =================================================

    const totalSalarios =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumeroDecreto(
                        registro.SALARIOBASE
                    );

            },
            0
        );


    const elementoSalarios =
        document.getElementById(
            "totalSalarios"
        );


    if (elementoSalarios) {

        elementoSalarios.textContent =
            formatearMonedaDecreto(
                totalSalarios
            );

    }


    // =================================================
    // TOTAL BONIFICACIÓN
    // =================================================

    const totalBonificacion =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    obtenerBonificacionDecreto(
                        registro
                    );

            },
            0
        );


    const elementoBonificacion =
        document.getElementById(
            "totalBonificacion"
        );


    if (elementoBonificacion) {

        elementoBonificacion.textContent =
            formatearMonedaDecreto(
                totalBonificacion
            );

    }


    // =================================================
    // TOTAL PAGO POR BONIFICACIÓN
    // =================================================

    const totalPagoPorBonificacion =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumeroDecreto(
                        registro.PAGOTOTALPORBONIFICACION
                    );

            },
            0
        );


    const elementoPagoTotalBonificacion =
        document.getElementById(
            "totalPagoPorBonificacion"
        );


    if (elementoPagoTotalBonificacion) {

        elementoPagoTotalBonificacion.textContent =
            formatearMonedaDecreto(
                totalPagoPorBonificacion
            );

    }


    // =================================================
    // TOTAL HORAS EXTRAS
    // =================================================

    const totalHorasExtras =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumeroDecreto(
                        registro.HORASEXTRAS
                    );

            },
            0
        );


    const elementoHorasExtras =
        document.getElementById(
            "totalHorasExtras"
        );


    if (elementoHorasExtras) {

        elementoHorasExtras.textContent =
            formatearNumeroDecreto(
                totalHorasExtras
            );

    }


    // =================================================
    // TOTAL HORAS DOBLES
    // =================================================

    const totalHorasDobles =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                return total +
                    convertirNumeroDecreto(
                        registro.HRSDOBLES
                    );

            },
            0
        );


    const elementoHorasDobles =
        document.getElementById(
            "totalHorasDobles"
        );


    if (elementoHorasDobles) {

        elementoHorasDobles.textContent =
            formatearNumeroDecreto(
                totalHorasDobles
            );

    }


    // =================================================
    // TOTAL A PAGAR
    // =================================================

    const totalPagoBonificacion =
        registrosDecreto.reduce(
            (
                total,
                registro
            ) => {

                const salario =
                    convertirNumeroDecreto(
                        registro.SALARIOBASE
                    );


                const extrasDobles =
                    convertirNumeroDecreto(
                        registro.TOTALEXTRASYDOBLES
                    );


                const bonificacion =
                    obtenerBonificacionDecreto(
                        registro
                    );


                return total +
                    salario +
                    extrasDobles +
                    bonificacion;

            },
            0
        );


    const elementoTotalPago =
        document.getElementById(
            "totalPagoBonificacion"
        );


    if (elementoTotalPago) {

        elementoTotalPago.textContent =
            formatearMonedaDecreto(
                totalPagoBonificacion
            );

    }

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFechaDecreto(
    fecha
) {

    if (!fecha) {

        return "";

    }


    try {

        const fechaObj =
            new Date(
                fecha
            );


        if (
            isNaN(
                fechaObj.getTime()
            )
        ) {

            return escapeHtmlDecreto(
                fecha
            );

        }


        const dia =
            String(
                fechaObj.getDate()
            )
                .padStart(
                    2,
                    "0"
                );


        const mes =
            String(
                fechaObj.getMonth() + 1
            )
                .padStart(
                    2,
                    "0"
                );


        const anio =
            fechaObj.getFullYear();


        return `${dia}/${mes}/${anio}`;

    }
    catch (error) {

        return escapeHtmlDecreto(
            fecha
        );

    }

}


// =====================================================
// FORMATEAR MONEDA
// =====================================================

function formatearMonedaDecreto(
    valor
) {

    const numero =
        convertirNumeroDecreto(
            valor
        );


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// =====================================================
// FORMATEAR NÚMERO
// =====================================================

function formatearNumeroDecreto(
    valor
) {

    const numero =
        convertirNumeroDecreto(
            valor
        );


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }
    );

}


// =====================================================
// CONVERTIR A NÚMERO
// =====================================================

function convertirNumeroDecreto(
    valor
) {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    const numero =
        Number(
            valor
        );


    return Number.isFinite(
        numero
    )
        ? numero
        : 0;

}


// =====================================================
// ESTADO
// =====================================================

function generarEstadoDecreto(
    estado
) {

    const valor =
        String(
            estado ?? ""
        )
            .trim()
            .toUpperCase();


    if (valor === "A") {

        return `

            <span
                class="badge bg-success">

                <i
                    class="bi bi-check-circle me-1">
                </i>

                Activo

            </span>

        `;

    }


    if (valor === "D") {

        return `

            <span
                class="badge bg-danger">

                <i
                    class="bi bi-x-circle me-1">
                </i>

                Inactivo

            </span>

        `;

    }


    return `

        <span
            class="badge bg-secondary">

            ${escapeHtmlDecreto(
                valor
            )}

        </span>

    `;

}


// =====================================================
// ESCAPAR HTML
// =====================================================

function escapeHtmlDecreto(
    valor
) {

    if (
        valor === null ||
        valor === undefined
    ) {

        return "";

    }


    return String(
        valor
    )

        .replace(
            /&/g,
            "&amp;"
        )

        .replace(
            /</g,
            "&lt;"
        )

        .replace(
            />/g,
            "&gt;"
        )

        .replace(
            /"/g,
            "&quot;"
        )

        .replace(
            /'/g,
            "&#039;"
        );

}


// =====================================================
// BUSCAR EN TABLA
// =====================================================

function buscarDecreto() {

    const input =
        document.getElementById(
            "buscarDecreto"
        );


    if (!input) {

        return;

    }


    const texto =
        input.value
            .trim()
            .toLowerCase();


    const registrosFiltrados =
        registrosDecreto.filter(
            registro => {

                return [

                    registro.IDINGRESONO,
                    registro.FECHAINGRESO,
                    registro.NOMBREEMPLEADO,
                    registro.DPI,
                    registro.NOMBREPUESTO,
                    registro.DIRECCION,
                    registro.SALARIOBASE,
                    registro.CANTIDADLABORALES,
                    registro.HORASESTABLECIDAS,
                    registro.HORASEXTRAS,
                    registro.PAGOORDINARIAHREXTRA,
                    registro.PAGOEXTRA,
                    registro.TOTALEXTRAPAGADO,
                    registro.HRSDOBLES,
                    registro.PAGOHRSDOBLE,
                    registro.TOTALHRSDOBLES,
                    registro.TOTALEXTRASYDOBLES,
                    registro.BONIFICACIONDECRETO,
                    registro.PAGOTOTALPORBONIFICACION,
                    registro.ESTADO

                ]

                    .some(
                        valor =>
                            String(
                                valor ?? ""
                            )
                                .toLowerCase()
                                .includes(
                                    texto
                                )
                    );

            }
        );


    renderizarRegistrosDecreto(
        registrosFiltrados
    );

}


// =====================================================
// RENDERIZAR REGISTROS FILTRADOS
// =====================================================

function renderizarRegistrosDecreto(
    registros
) {

    const registrosOriginales =
        registrosDecreto;


    registrosDecreto =
        registros;


    renderizarTablaDecreto();


    registrosDecreto =
        registrosOriginales;

}


// =====================================================
// BOTÓN PAGO DE BONIFICACIÓN
// =====================================================

function pagarBonificacionDecreto(
    idIngreso
) {

    console.log(
        "Abriendo pago de bonificación:",
        idIngreso
    );


    // =================================================
    // BUSCAR REGISTRO
    // =================================================

    const registro =
        registrosDecreto.find(
            item =>
                Number(
                    item.IDINGRESONO
                ) ===
                Number(
                    idIngreso
                )
        );


    // =================================================
    // VALIDAR REGISTRO
    // =================================================

    if (!registro) {

        console.error(
            "No se encontró el registro:",
            idIngreso
        );


        alert(
            "No se encontró la información del empleado."
        );


        return;

    }


    // =================================================
    // LLENAR MODAL
    // =================================================

    llenarModalBonificacionDecreto(
        registro
    );


    // =================================================
    // OBTENER MODAL
    // =================================================

    const elementoModal =
        document.getElementById(
            "modalBonificacion"
        );


    if (!elementoModal) {

        console.error(
            "No se encontró el modal #modalBonificacion"
        );


        alert(
            "No se encontró el modal de bonificación."
        );


        return;

    }


    // =================================================
    // VALIDAR BOOTSTRAP
    // =================================================

    if (
        typeof bootstrap === "undefined"
    ) {

        console.error(
            "Bootstrap no está cargado."
        );


        alert(
            "No se pudo abrir el modal porque Bootstrap no está cargado."
        );


        return;

    }


    // =================================================
    // ABRIR MODAL
    // =================================================

    const modal =
        bootstrap.Modal.getOrCreateInstance(
            elementoModal
        );


    modal.show();

}


// =====================================================
// LLENAR MODAL DE BONIFICACIÓN
// =====================================================

function llenarModalBonificacionDecreto(
    registro
) {

    // =================================================
    // ID EMPLEADO
    // =================================================

    establecerValorDecreto(
        "mostrarIdEmpleado",
        registro.IDEMPLEADO ??
        registro.IDINGRESONO
    );


    // =================================================
    // NOMBRE EMPLEADO
    // =================================================

    establecerValorDecreto(
        "nombreEmpleado",
        registro.NOMBREEMPLEADO
    );


    // =================================================
    // DPI
    // =================================================

    establecerValorDecreto(
        "dpiEmpleado",
        registro.DPI
    );


    // =================================================
    // PUESTO
    // =================================================

    establecerValorDecreto(
        "puestoEmpleado",
        registro.NOMBREPUESTO
    );


    // =================================================
    // DIRECCIÓN
    // =================================================

    establecerValorDecreto(
        "direccionEmpleado",
        registro.DIRECCION
    );


    // =================================================
    // SALARIO BASE
    // =================================================

    establecerValorDecreto(
        "salarioBase",
        formatearMonedaDecreto(
            registro.SALARIOBASE
        )
    );


    // =================================================
    // DÍAS LABORALES
    // =================================================

    establecerValorDecreto(
        "diasLaborales",
        formatearNumeroDecreto(
            registro.CANTIDADLABORALES
        )
    );


    // =================================================
    // HORAS ESTABLECIDAS
    // =================================================

    establecerValorDecreto(
        "horasEstablecidas",
        formatearNumeroDecreto(
            registro.HORASESTABLECIDAS
        )
    );


    // =================================================
    // FECHA INGRESO
    // =================================================

    establecerValorDecreto(
        "fechaIngreso",
        convertirFechaInputDecreto(
            registro.FECHAINGRESO
        )
    );


    // =================================================
    // ESTADO
    // =================================================

    establecerValorDecreto(
        "estadoBonificacion",
        registro.ESTADO || "A"
    );


    // =================================================
    // HORAS EXTRAS
    // =================================================

    establecerValorDecreto(
        "horasExtras",
        formatearNumeroDecreto(
            registro.HORASEXTRAS
        )
    );


    // =================================================
    // PAGO ORDINARIO
    // =================================================

    establecerValorDecreto(
        "pagoOrdinariaHrExtra",
        formatearMonedaDecreto(
            registro.PAGOORDINARIAHREXTRA
        )
    );


    // =================================================
    // PAGO HORA EXTRA
    // =================================================

    establecerValorDecreto(
        "pagoExtra",
        formatearMonedaDecreto(
            registro.PAGOEXTRA
        )
    );


    // =================================================
    // TOTAL HORAS EXTRAS
    // =================================================

    establecerValorDecreto(
        "totalExtraPagado",
        formatearMonedaDecreto(
            registro.TOTALEXTRAPAGADO
        )
    );


    // =================================================
    // HORAS DOBLES
    // =================================================

    establecerValorDecreto(
        "hrsDobles",
        formatearNumeroDecreto(
            registro.HRSDOBLES
        )
    );


    // =================================================
    // PAGO HORA DOBLE
    // =================================================

    establecerValorDecreto(
        "pagoHrsDoble",
        formatearMonedaDecreto(
            registro.PAGOHRSDOBLE
        )
    );


    // =================================================
    // TOTAL HORAS DOBLES
    // =================================================

    establecerValorDecreto(
        "totalHorasDoblesModal",
        formatearMonedaDecreto(
            registro.TOTALHRSDOBLES
        )
    );


    // =================================================
    // TOTAL EXTRAS Y DOBLES
    // =================================================

    establecerValorDecreto(
        "totalExtrasDobles",
        formatearMonedaDecreto(
            registro.TOTALEXTRASYDOBLES
        )
    );


    // =================================================
    // BONIFICACIÓN DECRETO
    // =================================================

    const valorBonificacion =
        obtenerBonificacionDecreto(
            registro
        );


    establecerValorDecreto(
        "bonificacionDecreto",
        valorBonificacion.toFixed(2)
    );


    // =================================================
    // TOTAL BONIFICACIÓN
    // =================================================

    establecerValorDecreto(
        "totalBonificacionModal",
        valorBonificacion.toFixed(2)
    );


    // =================================================
    // PAGO TOTAL POR BONIFICACIÓN
    // =================================================

    const pagoTotalPorBonificacion =
        calcularPagoTotalBonificacionModal(
            registro
        );


    establecerValorDecreto(
        "pagoTotalPorBonificacion",
        pagoTotalPorBonificacion.toFixed(2)
    );


    // =================================================
    // RESUMEN SALARIO
    // =================================================

    establecerValorDecreto(
        "resumenSalario",
        formatearMonedaDecreto(
            registro.SALARIOBASE
        )
    );


    // =================================================
    // RESUMEN EXTRAS Y DOBLES
    // =================================================

    establecerValorDecreto(
        "resumenExtrasDobles",
        formatearMonedaDecreto(
            registro.TOTALEXTRASYDOBLES
        )
    );


    // =================================================
    // RESUMEN BONIFICACIÓN
    // =================================================

    establecerValorDecreto(
        "resumenBonificacion",
        formatearMonedaDecreto(
            pagoTotalPorBonificacion
        )
    );


    // =================================================
    // TOTAL GENERAL
    // =================================================

    const salario =
        convertirNumeroDecreto(
            registro.SALARIOBASE
        );


    const extrasDobles =
        convertirNumeroDecreto(
            registro.TOTALEXTRASYDOBLES
        );


    const totalGeneral =
        salario +
        extrasDobles +
        pagoTotalPorBonificacion;


    establecerValorDecreto(
        "resumenTotal",
        formatearMonedaDecreto(
            totalGeneral
        )
    );


    // =================================================
    // GUARDAR IDINGRESONO
    // EN BOTÓN DEL MODAL
    // =================================================

    const botonGuardar =
        document.getElementById(
            "btnGuardarBonificacion"
        );


    if (botonGuardar) {

        botonGuardar.dataset.idIngreso =
            registro.IDINGRESONO;

    }


    // =================================================
    // GUARDAR ID EN MODAL
    // =================================================

    const modal =
        document.getElementById(
            "modalBonificacion"
        );


    if (modal) {

        modal.dataset.idIngreso =
            registro.IDINGRESONO;

    }

}


// =====================================================
// ESTABLECER VALOR
// =====================================================

function establecerValorDecreto(
    id,
    valor
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `No se encontró el elemento #${id}`
        );

        return;

    }


    if (
        elemento.tagName === "INPUT" ||
        elemento.tagName === "SELECT" ||
        elemento.tagName === "TEXTAREA"
    ) {

        elemento.value =
            valor === null ||
            valor === undefined
                ? ""
                : valor;

        return;

    }


    elemento.textContent =
        valor === null ||
        valor === undefined
            ? ""
            : valor;

}


// =====================================================
// CONVERTIR FECHA PARA INPUT DATE
// =====================================================

function convertirFechaInputDecreto(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const texto =
        String(
            fecha
        );


    const coincidencia =
        texto.match(
            /^(\d{4})-(\d{2})-(\d{2})/
        );


    if (coincidencia) {

        return (
            coincidencia[1] +
            "-" +
            coincidencia[2] +
            "-" +
            coincidencia[3]
        );

    }


    const fechaObj =
        new Date(
            fecha
        );


    if (
        Number.isNaN(
            fechaObj.getTime()
        )
    ) {

        return "";

    }


    const anio =
        fechaObj.getFullYear();


    const mes =
        String(
            fechaObj.getMonth() + 1
        )
            .padStart(
                2,
                "0"
            );


    const dia =
        String(
            fechaObj.getDate()
        )
            .padStart(
                2,
                "0"
            );


    return (
        anio +
        "-" +
        mes +
        "-" +
        dia
    );

}


// =====================================================
// LIMPIAR BÚSQUEDA
// =====================================================

function limpiarBusquedaDecreto() {

    const input =
        document.getElementById(
            "buscarDecreto"
        );


    if (input) {

        input.value = "";

    }


    renderizarTablaDecreto();

}


// =====================================================
// EVENTO BUSCAR
// =====================================================

document.addEventListener(
    "input",
    function (evento) {

        if (
            evento.target &&
            evento.target.id ===
            "buscarDecreto"
        ) {

            buscarDecreto();

        }

    }
);


// =====================================================
// EVENTO BOTÓN LIMPIAR
// =====================================================

document.addEventListener(
    "click",
    function (evento) {

        const boton =
            evento.target.closest(
                "#btnLimpiarBusqueda"
            );


        if (!boton) {

            return;

        }


        limpiarBusquedaDecreto();

    }
);


// =====================================================
// EVENTO BOTÓN GUARDAR
// =====================================================

document.addEventListener(
    "click",
    function (evento) {

        const boton =
            evento.target.closest(
                "#btnGuardarBonificacion"
            );


        if (!boton) {

            return;

        }


        guardarBonificacionDecreto();

    }
);


// =====================================================
// INICIALIZACIÓN AUTOMÁTICA
// =====================================================

if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(
        "DOMContentLoaded",
        inicializarDecreto
    );

}
else {

    inicializarDecreto();

}


// =====================================================
// EXPORTAR / DISPONIBILIZAR
// =====================================================

window.inicializarDecreto =
    inicializarDecreto;


window.cargarTablaDecreto =
    cargarTablaDecreto;


window.buscarDecreto =
    buscarDecreto;


window.pagarBonificacionDecreto =
    pagarBonificacionDecreto;


window.llenarModalBonificacionDecreto =
    llenarModalBonificacionDecreto;


window.limpiarBusquedaDecreto =
    limpiarBusquedaDecreto;


window.obtenerBonificacionDecreto =
    obtenerBonificacionDecreto;


window.calcularPagoTotalBonificacionModal =
    calcularPagoTotalBonificacionModal;


window.guardarBonificacionDecreto =
    guardarBonificacionDecreto;

